import { render, staticRenderFns } from "./lmsContact.vue?vue&type=template&id=307dbfdc&"
import script from "./lmsContact.vue?vue&type=script&lang=js&"
export * from "./lmsContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports